<template>
  <Modal :title="title" @close-modal="$emit('close-modal', false)">
    <router-link
      v-for="compView in compViews"
      :key="compView.competition.competitionId"
      :to="`/archiwum/${compView.redirectUrl}`"
      :disabled="compView.competition.id === null"
      class="competition"
    >
      <div class="title">
        {{ compView.competition.name }}
      </div>

      <div class="subtitle">
        {{ compView.competition.year }} | {{ compView.competition.cityName }}
        <span v-if="compView.competition.dayNo">| dzień {{ compView.competition.dayNo }}</span>
      </div>

      <img
        v-if="compView.competition.banerUrl"
        :src="compView.competition.banerUrl"
        :alt="compView.competition.name"
        class="bg"
      />
    </router-link>
  </Modal>
</template>

<script>
import Modal from "@/components/Modal"

export default {
  name: "CompetitionsModal",

  components: {
    Modal,
  },

  props: {
    title: String,
    compViews: Array,
  },
}
</script>

<style lang="scss" scoped>
$_thumbSize: 15rem;
$_breakpoint: 900px;

.competition {
  color: #fff;
  text-align: center;
  min-height: $_thumbSize;
  padding: 2rem;
  background: #000;
  box-shadow: 0 0 1rem 1rem rgba(#000, 0.15);
  border: 0.35rem solid rgba(#fff, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  margin: 2rem;

  & + .competition {
    margin-top: 4rem;
  }

  &[disabled] {
    pointer-events: none;
    background: rgba(#000, 0.55);

    .bg {
      opacity: 0.15;
      filter: grayscale(1);
    }
  }

  .title {
    font-weight: bold;
    text-transform: uppercase;
    font-size: 1.5rem;
    z-index: 1;
  }

  .subtitle {
    font-size: 1rem;
    text-transform: uppercase;
    z-index: 1;
  }

  @media (min-width: $_breakpoint) {
    .title {
      font-size: 2.5rem;
      font-weight: 800;
    }

    .subtitle {
      font-size: 1.5rem;
    }
  }

  .bg {
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 0.15;
    transition: opacity 250ms, transform 250ms;
    pointer-events: none;
    position: absolute;
    top: 0;
    left: 0;
  }

  &:hover .bg {
    opacity: 0.35;
    transform: scale(1.025);
  }
}
</style>
